module.exports = { "default": require("core-js/library/fn/object/create"), __esModule: true };


/*****************
 ** WEBPACK FOOTER
 ** ./~/_babel-runtime@6.23.0@babel-runtime/core-js/object/create.js
 ** module id = 378
 ** module chunks = 0 1
 **/